import Phaser from "phaser";
import { HubMenu } from "./game/ui/HubMenu";
import { TownPanel } from "./game/ui/TownPanel";
import { Portada } from "./game/ui/Portada";
import { Sfx } from "./game/systems/Sfx";
import { BootScene } from "./game/scenes/BootScene";
import { CityScene } from "./game/scenes/CityScene";
import { ObrasScene } from "./game/scenes/ObrasScene";
import { FabricaScene } from "./game/scenes/FabricaScene";
import { LaboScene } from "./game/scenes/LaboScene";
import { TorreScene } from "./game/scenes/TorreScene";
import { GrisScene } from "./game/scenes/GrisScene";
import { CentralScene } from "./game/scenes/CentralScene";
import { PoligonoScene } from "./game/scenes/PoligonoScene";
import { BomberosScene } from "./game/scenes/BomberosScene";
import { HospitalScene } from "./game/scenes/HospitalScene";
import { HotelScene } from "./game/scenes/HotelScene";
import { ObrasMicroScene } from "./game/scenes/ObrasMicroScene";

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "app",
  backgroundColor: "#1b140c",
  scale: {
    // RESIZE: el lienzo LLENA el marco (#stage) en cualquier proporción, sin
    // franjas negras. FIT dejaba banda a los lados en pantallas anchas y bajas.
    mode: Phaser.Scale.RESIZE,
    width: 1280,
    height: 720,
  },
  render: { antialias: true, pixelArt: false, preserveDrawingBuffer: true },
  scene: [BootScene, CityScene, ObrasScene, ObrasMicroScene, FabricaScene, LaboScene, TorreScene, GrisScene, CentralScene, PoligonoScene, BomberosScene, HospitalScene, HotelScene],
};

const game = new Phaser.Game(config);

// menú lateral fijo (identidad, progreso, misiones, ayuda, personajes)
new HubMenu();
// panel derecho: cartel de Villa Segura + misión de EPI + estado de la ciudad
new TownPanel();

// quita el aviso de carga una vez arranca el bundle
document.getElementById("boot-fallback")?.remove();

// PORTADA de inicio (estilo landing) por encima del juego. El juego arranca
// detrás; al pulsar "Empezar" la portada se desvanece y ese gesto desbloquea
// el audio. Si en el futuro se quiere saltar, basta con no instanciarla.
new Portada(() => {
  Sfx.unlock();
  Sfx.resolve();
});

// Phaser mide mal el contenedor flex (#stage) al arrancar y no se recupera solo:
// el juego se quedaba pequeño y descentrado. Le pasamos el tamaño real del
// escenario y lo refrescamos cuando cambie, así el lienzo llena el marco.
const stageEl = document.getElementById("stage");
if (stageEl) {
  const fitToStage = (): void => {
    const r = stageEl.getBoundingClientRect();
    if (r.width > 0 && r.height > 0) {
      game.scale.setParentSize(r.width, r.height);
      game.scale.refresh();
    }
  };
  new ResizeObserver(fitToStage).observe(stageEl);
  window.addEventListener("resize", fitToStage);
  requestAnimationFrame(fitToStage);
}

// En desarrollo, expone la instancia para depuración/pruebas (no en producción).
if (import.meta.env.DEV) {
  (window as unknown as { __EPI_GAME: Phaser.Game }).__EPI_GAME = game;
  import("./game/config").then(({ RUNTIME }) => {
    (window as unknown as { __EPI_RUNTIME: typeof RUNTIME }).__EPI_RUNTIME = RUNTIME;
  });
  import("./game/systems/Sfx").then(({ Sfx }) => {
    (window as unknown as { __EPI_SFX: typeof Sfx }).__EPI_SFX = Sfx;
  });
}
